
import { useLocation } from "react-router-dom";
import { usePublicPaths } from "@/hooks/usePublicPaths";

const BackgroundWrapper = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const isPublicPath = usePublicPaths();
  const isPublic = isPublicPath(location.pathname);

  return (
    <>
      {isPublic ? (
        // Public routes background - soft light gray that matches signup/signin
        <div className="fixed inset-0 -z-10 h-full w-full bg-slate-50" />
      ) : (
        // Authenticated routes background - white
        <div className="fixed inset-0 -z-10 h-full w-full bg-white" />
      )}
      <div className="flex min-h-dvh flex-col">{children}</div>
    </>
  );
};

export default BackgroundWrapper;
